interface SpotifyIconProps {
    color?: string;
    className?: string;
}

function SpotifyIcon({ color = 'currentColor', className = null }: SpotifyIconProps) {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="40px"
            height="39.9px"
            viewBox="0 0 40 39.9"
            xmlSpace="preserve"
            className={className || undefined}
        >
            <path
                fill={color}
                d="M0,19.9c0,11,9,20,20,20s20-9,20-20S31,0,20,0S0,8.9,0,19.9z M27.4,29.2c-4.6-2.9-10.6-3.6-17.5-2C8.2,27.4,8,25,9.4,24.8
	c7.6-1.8,14-1,19.3,2.3C30,27.9,28.7,29.9,27.4,29.2z M29.4,23.8c-5.4-3.3-13.6-4.3-19.9-2.4c-2,0.6-2.7-2.5-0.8-3
	c7.3-2.1,16.2-1.1,22.4,2.7C32.7,22.3,31.1,24.9,29.4,23.8z M8.6,15.4c-2,0.7-3.3-2.7-1.1-3.6c7-2.1,18.9-1.8,26.3,2.6
	c2,1.1,0.1,4.4-2,3.2C25.4,13.8,14.6,13.5,8.6,15.4z"
            />
        </svg>
    );
}

export default SpotifyIcon;
